<template>
  <v-form
    id="resetPasswordForm"
    ref="resetPasswordForm"
  >
    <v-card-text>
      <PolteqTextField
        v-model="email"
        field-id="emailField"
        :label="i18n.t('fields.emailaddress')"
        icon="mdi-email-outline"
        type="email"
        autocomplete="username"
        :rules="[rules.required]"
      />
      <PolteqTextField
        v-model="newpassword"
        field-id="passwordField"
        :label="i18n.t('fields.newpassword')"
        icon="mdi-lock-outline"
        type="password"
        autocomplete="new-password"
        :rules="[rules.password]"
      />
      <PolteqTextField
        v-model="confirmpassword"
        field-id="confirmPasswordField"
        :label="i18n.t('fields.confirmpassword')"
        icon="mdi-lock-check-outline"
        type="password"
        autocomplete="new-password"
        :rules="[rules.password_match(newpassword, confirmpassword)]"
      />
    </v-card-text>
    <v-card-text style="text-align: end">
      <PolteqButton
        button-id="changePasswordButton"
        icon="mdi-email-arrow-right-outline"
        :button-text="i18n.t('buttons.changepassword')"
        @click="resetPassword(email, code, newpassword)"
      />
    </v-card-text>
  </v-form>
</template>

<script lang="ts" src="./ResetPasswordForm.ts" />
